import { HierarchyParser } from "../loaders/HierarchyParser";
import { ClassUtils } from "../utils/ClassUtils";
import { Prefab } from "./HierarchyResource";
export class PrefabImpl extends Prefab {
    constructor(api, data) {
        super();
        this.api = api || PrefabImpl.v3;
        this.data = data;
    }
    create(options, errors) {
        let runtime = ClassUtils.getRuntime(this.url);
        if (runtime) {
            if (!options)
                options = { runtime };
            else if (!options.runtime)
                options = Object.assign({ runtime }, options);
        }
        let ret = this.api.parse(this.data, options, errors);
        if (Array.isArray(ret)) {
            if (ret.length == 1) {
                ret[0].url = this.url;
            }
            return ret[0];
        }
        else {
            ret.url = this.url;
            return ret;
        }
    }
}
PrefabImpl.v3 = HierarchyParser;
PrefabImpl.v2 = null;
